export enum ViewPlans {

  PRICE = 'Preço',
  PRODUCT = 'Produto',
  COVERAGE = 'Cobertura',
  ELIGIBILITY = 'Elegibilidade'

}